<template>
  <div>
    <v-data-table
      :headers="resumeItemDataTableHeaders"
      :items="computedResumeItemList"
      class="elevation-1 ma-5"
      :no-data-text="$t('common_no_data')"
      :no-results-text="$t('common_no_results')"
      item-key="Index"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:[`item.BuyOrRentType`]="{ item }">
        {{ turnBuyOrRentType(item.BuyOrRentType) }}
      </template>
      <template v-slot:[`item.InstallPosition`]="{ item }">
        {{ turnInstallPosition(item.InstallPosition) }}
      </template>
      <template v-slot:[`item.Edit`]="{ item }">
        <v-icon
          small
          v-if="!(resumeList.length === 1)"
          @click="confirmDeleteResumeItem(item)"
          :disabled="isAllTextFieldDisable"
        >
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { BuyOrRentType } from '@/js/BuyOrRentType'
import { ItemInstallPositionType } from '@/js/ItemInstallPositionType'
import { HttpInstallPosition } from '@/js/http-Manager'
export default {
  name: 'ChangeDetailResumeItem',
  props: {
    resumeList: {
      type: Array
    },
    isAllTextFieldDisable: {
      type: Boolean
    }
  },
  data: () => ({
    installPositionList: []
  }),
  async mounted () {
    await this.getInstallPositionList()
  },
  watch: {},
  computed: {
    computedResumeItemList () {
      let array = []
      this.resumeList.forEach((element, index) => {
        array.push(Object.assign({ Index: index }, element))
      })
      return array
    },
    resumeItemDataTableHeaders () {
      return [
        { text: this.$t('installation_notice_item_main_name'), align: 'start', value: 'BomName' },
        { text: '主設備描述', align: 'start', value: 'BomDescribe' },
        { text: this.$t('quotation_item_number'), align: 'start', value: 'Number' },
        { text: this.$t('quotation_item_name'), align: 'start', value: 'Name' },
        {
          text: this.$t('installation_notice_item_buy_or_rent'),
          align: 'center',
          value: 'BuyOrRentType'
        },
        { text: this.$t('quotation_item_unit'), align: 'start', value: 'Unit' },
        { text: this.$t('quotation_remove_item_quantity'), align: 'end', value: 'Quantity' },
        {
          text: this.$t('quotation_item_install_position'),
          align: 'start',
          value: 'InstallPosition'
        },
        {
          text: this.$t('quotation_item_serialnumber'),
          align: 'start',
          value: 'SerialNumber.Number'
        },
        {
          text: this.$t('quotation_item_is_customer_device'),
          align: 'start',
          value: 'IsCustomerDevice'
        },
        { text: this.$t('quotation_item_remark'), align: 'start', value: 'Remark' },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false }
      ]
    }
  },
  methods: {
    turnBuyOrRentType (val) {
      return BuyOrRentType.BuyOrRentTypeName(val)
    },
    turnInstallPosition (value) {
      return ItemInstallPositionType.getFormInstallPositionTypeName(
        value,
        this.installPositionList
      )
    },
    async getInstallPositionList () {
      let response = await HttpInstallPosition.GetAllInstallPosition()
      this.installPositionList = response.status === 200 ? response.data.Data : []
    },
    confirmDeleteResumeItem (item) {
      this.$emit('confirmDeleteResumeItem', item)
    }
  }
}
</script>
